<template>
    <div>
        <article class="media pb-3">
            <div class="media-left pt-1 mr-2">
                <div>
                    <div
                        :style="getAvatarStyle"
                        class="image is-24x24 is-pulled-right"
                    />
                </div>
            </div>
            <div class="media-content">
                <div>
                    <p class="has-text-weight-bold">
                        {{ comment.owner.alias || comment.owner.username }}
                    </p>
                    <p class="is-size-7">
                        {{ comment.modified | timeDifference }}
                        <span
                            v-if="comment.edited"
                            v-t="'App.content_edited'"
                            class="is-italic is-size-7"
                        ></span>
                    </p>
                </div>
                <span
                    v-if="comment.deleted"
                    v-t="'App.comment_deleted'"
                    class="is-italic"
                ></span>
            </div>
            <div
                v-if="!comment.deleted"
                class="media-right pt-2 pr-6"
                @click="$emit('like')"
            >
                <div
                    :class="
                        comment.liked ? 'has-text-primary' : 'has-text-grey'
                    "
                    class="has-cursor-pointer"
                >
                    <span class="icon">
                        <i class="mdi mdi-24px mdi-heart-outline" />
                    </span>
                    <span class="pl-1 lb-likes-count">
                        {{ comment.likes ? comment.likes : 0 }}
                    </span>
                </div>
            </div>
        </article>
        <app-editable-comment
            v-if="!comment.deleted"
            :message="comment.message"
            :editable="canEdit"
            :dropdown="dropdown"
            class="pl-5 ml-4 mr-6 pb-3"
            @edit="emitEdit"
            @delete="$emit('delete', $event)"
        />
    </div>
</template>
<script>
import moment from 'moment';
import AppEditableComment from '@/components/AppEditableComment';
import { avatarStyle } from '@/lib/helpers';
export default {
    components: {
        AppEditableComment,
    },
    filters: {
        timeDifference(timestamp) {
            moment.locale('es'); // TODO use vue moment to better handle this
            return moment(moment(timestamp), 'minutes').fromNow();
        },
    },
    props: {
        dropdown: {
            type: Boolean,
            default: false,
        },
        comment: {
            type: Object,
            default: () => {
                return {};
            },
        },
    },
    computed: {
        canEdit() {
            return (
                this.comment.owner.owner === this.$store.getters.user.owner &&
                !this.comment.deleted
            );
        },
        getAvatarStyle() {
            return avatarStyle(this.comment.owner);
        },
    },
    methods: {
        emitEdit(message) {
            this.comment.message = message;
            this.$emit('edit', this.comment);
        },
        highlightUserMentions(message) {
            return (
                message &&
                message.replace(
                    /((?=[^\w!])@\w+\b)/gi,
                    "<a class='tag is-primary is-light is-size-6'>$&</a>"
                )
            );
        },
    },
};
</script>

<style scoped></style>
